import type { IconData } from '@stacksjs/iconify-core'

export const recordingTape1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 22a19 19 0 1 0 38 0a19 19 0 1 0-38 0\"/><path d=\"M18 12a4 4 0 1 0 8 0a4 4 0 1 0-8 0m14 6a4 4 0 1 0 0 8a4 4 0 1 0 0-8M18 32a4 4 0 1 1 8 0a4 4 0 1 1-8 0m-6-14a4 4 0 1 0 0 8a4 4 0 1 0 0-8m29 4c0 7-4 14.333-4 18s2.2 5 4 5c2.7 0 4-2.292 4-7.333M22 22.5a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default recordingTape1
